// export const DEFAULT_PAGE_SIZES = [5, 10, 15];
export const DEFAULT_PAGE_SIZES = [10, 20, 30, 50, 100, 200];

// storerank-下钻展开宽表排序rank
export const RANKING_NUMBER_LIST = ['1-3', '4-10', '11-50', '51-200'];
